<section class="pit-card hero" aria-label="Sócio em análise">
  <div class="hero__main">
    <!-- A conclusão vem primeiro: é o que o olho tem de achar antes de qualquer aviso (Beleza, foco). -->
    @if (conclusion(); as c) {
      <span [class]="'pit-tag hero__tag ' + c.css">{{ c.label }}</span>
      <h2 class="hero__conclusion">{{ c.title }}</h2>
    } @else {
      <h2 class="hero__conclusion">{{ displayName() }}</h2>
    }
    <p class="hero__line">
      <b>{{ displayName() }}</b>
      @for (part of roleLine(); track part) {
        <span> · {{ part }}</span>
      }
      @if (latest(); as last) {
        <span>
          · IRPF {{ last.exerciseYear }} {{ kindLabel(last.kind).toLowerCase() }}
          @if (last.deliveredAt) {
            · entregue em {{ last.deliveredAt | vaultDate }}
          }
        </span>
      } @else {
        <span> · Nenhuma declaração lida</span>
      }
    </p>
    @if (identityLine()) {
      <p class="pit-caption">{{ identityLine() }}</p>
    }
    @if (exposure(); as text) {
      <p class="pit-caption">{{ text }}</p>
    }
  </div>

  <app-pit-return-timeline
    class="hero__timeline"
    [returns]="partner().returns"
    [selectedCalendarYear]="partner().selectedCalendarYear"
    (selectYear)="selectYear.emit($event)" />
</section>
